<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
    </label>
  }

  @if (options().length < 1) {
    <div class="text-xs text-orange-500">WARNING! no options</div>
  }

  @if (isReadOnly()) {
    <input
      pInputText
      [value]="selectedOptionTranslations() | translateDirectus"
      [disabled]="true"
      class="w-full readOnly"
    />
  } @else {
    <p-select
      [id]="id()"
      [attr.data-testid]="id() + '-input'"
      [formControlName]="fieldName()"
      [options]="options()"
      optionValue="id"
      [placeholder]="placeholder() | transloco"
      [showClear]="showClear()"
      [filter]="filter()"
      [ngClass]="{'p-invalid': form.get(fieldName())?.invalid && form.get(fieldName())?.touched}"
      class="w-full"
      appendTo="body"
    >
      <ng-template #selectedItem let-selectedOption>
        @if (selectedOption) {
          <div class="flex items-center gap-3">
            <span>{{ selectedOption.translations | translateDirectus }}</span>
            @if (selectedOption.tooltip?.key) {
              <app-directus-tooltip
                tooltipStyleClass="tooltip-bg-second-level"
                [tooltipKey]="selectedOption.tooltip?.key"
              ></app-directus-tooltip>
            }
          </div>
        }
      </ng-template>

      <ng-template #item let-item>
        <div class="flex items-center justify-between w-full">
          <div class="flex items-center gap-3">
            <span>{{ item.translations | translateDirectus }}</span>
            @if (item.tooltip?.key) {
              <app-directus-tooltip
                tooltipStyleClass="tooltip-bg-second-level"
                [tooltipKey]="item.tooltip?.key"
              ></app-directus-tooltip>
            }
          </div>
        </div>
      </ng-template>
    </p-select>
  }
</div>
